import React from 'react';
import PropTypes from 'prop-types';
import CompatibilityIcon from '../../../shared/icons/icon-compatibility.svg';


const CompatibilityLink = ({ url, isSmb }) => (
  <div className="product-details__compatibility-container">
    BEFORE YOU BUY
    <div className="product-details__compatibility-wrapper">
      <a
        className="product-details__compatibility-link"
        href={url}
        rel="noreferrer"
        target="_blank"
      >
        <CompatibilityIcon className="product-details__compatibility-link-icon" />
        Confirm it’s compatible with your {isSmb ? "premise" : "home"}
      </a>
    </div>
  </div>
);

CompatibilityLink.propTypes = {
  url: PropTypes.string.isRequired,
  isSmb: PropTypes.bool.isRequired,
};

export default CompatibilityLink;
